"use client";

import { useUser } from "@clerk/nextjs";

import { RequiredBuyPremiumButton } from "@/app/_components/required/buy-premium-button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import { useFilter } from "../use-filter";
import { filterSearchParam } from "@/filters";

import { getUserPlanByMetadata } from "@/helper/user/client";

import { areaSizes } from "@/constants";

export function Size() {
  const [{ tamanhoPropriedade, tamanhoArea }, setSearchParam] = useFilter();
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);

  return (
    <RequiredBuyPremiumButton>
      <div className="flex flex-col gap-8 p-4">
        <div className="flex flex-col gap-2">
          <p className="text-sm">Tamanho da área</p>
          <Select
            onValueChange={(value) => {
              if (hasPaidPlan && value) {
                setSearchParam({
                  [filterSearchParam.tamanhoArea]:
                    value === "-1" ? null : Number(value),
                });
              }
            }}
            defaultValue={tamanhoArea?.toString() ?? "-1"}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione o tamanho da área" />
            </SelectTrigger>
            <SelectContent>
              {areaSizes.map((size) => (
                <SelectItem key={size} value={size}>
                  +{size}m²
                </SelectItem>
              ))}
              <SelectItem value="-1">Sem máximo</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="flex flex-col gap-2">
          <p className="text-sm">Tamanho da propriedade</p>
          <Select
            onValueChange={(value) => {
              if (hasPaidPlan && value) {
                setSearchParam({
                  [filterSearchParam.tamanhoPropriedade]:
                    value === "-1" ? null : Number(value),
                });
              }
            }}
            defaultValue={tamanhoPropriedade?.toString() ?? "-1"}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione o tamanho da propriedade" />
            </SelectTrigger>
            <SelectContent>
              {areaSizes.map((size) => (
                <SelectItem key={size} value={size}>
                  +{size}m²
                </SelectItem>
              ))}
              <SelectItem value="-1">Sem máximo</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </RequiredBuyPremiumButton>
  );
}
